import {NAME} from "./constants";

export const SET_FETCHING = `${NAME}/SET_FETCHING`;

export const setFetching = (id, isFetching) => ({
    type: SET_FETCHING,
    id,
    isFetching,
});
